import Client from "./components/Client";
import GetInTouch from "./components/GetInTouch";
import Hero from "./components/Hero";
import Landing from "./components/Landing";
import SectionComponents from "./components/SectionComponents";
import Why from "./components/Why";
import SEO from "../../components/common/SEO";

const index = () => {
  const structuredData = {
    "@context": "https://schema.org",
    "@type": "WebSite",
    "name": "Youstad",
    "description": "Comprehensive academy management system with Ledger for invoicing, Docket for timetables, and Bite for canteen management",
    "url": "https://youstad.com",
    "potentialAction": {
      "@type": "SearchAction",
      "target": "https://youstad.com/search?q={search_term_string}",
      "query-input": "required name=search_term_string"
    }
  };

  return (
    <>
      <SEO
        title="Youstad - Academy Management System | Streamline Your Educational Operations"
        description="Transform your academy with Youstad's comprehensive management system. Features Ledger for invoicing, Docket for timetables, and Bite for canteen management. Optimize operations and boost success."
        keywords="academy management, school management system, educational software, invoice generator, timetable creator, canteen management, student management, academy operations"
        url="https://youstad.com"
        structuredData={structuredData}
      />
      <Hero />
      <Landing />
      <Why />
      <SectionComponents />
      <Client />
      <GetInTouch />
    </>
  );
};

export default index;
